import {
    paragraph,
    link,
    head,
    list,
    quote,
    checklist,
    image,
    table,
    code,
    delimiter,
    raw,
    embed,
    warning,
    attaches,
    gallery,
    carousel,
} from './component';

let value = '';

const renderHTML = (val) => {
    value = '';
    try {
        val.forEach((items) => {
            //console.log(items);
            switch (items.type) {
            case "paragraph":
                value += paragraph(items.data.text);
                break;
            case "linkTool":
                value += link(items.data);
                break;
            case "header":
                value += head(items.data.text, items.data.level);
                break;
            case "list":
                value += list(items.data);
                break;
            case "raw":
                value += raw(items.data.html);
                break;
            case "quote":
                value += quote(items.data.caption, items.data.text);
                break;
            case "checklist":
                value += checklist(items.data.items);
                break;
            case "embed":
                value += embed(items.data);
                break;
            case "delimiter":
                value += delimiter();
                break;
            case "image":
                value += image(items.data);
                break;
            case "table":
                value += table(items);
                break;
            case "code":
                value += code(items);
                break;
            case "attaches":
                value += attaches(items);
                break;
            case "gallery":
                value += gallery(items.data);
                break;
            case "carousel":
                value += carousel(items.data);
                break;
            case "warning":
                value += warning(items.data);
                break;
            default:
                value += '';
            }
        });
    } catch (err) {
        //
    }
    return value;
};

export { renderHTML }
